<template>
  <BForm
    @submit.prevent="gravar"
    class="formulario">
    <InputBasico
      type="text"
      label="Nome*"
      name="inputNome"
      class="inputNome"
      v-model="form.nome"
      v-validate="'required'"
      :errorsBag="errors" />

    <InputBasico
      type="email"
      label="E-mail"
      name="inputEmail"
      class="inputEmail"
      v-model="form.email"
      :errorsBag="errors" />

    <InputCelular
      label="WhatsApp"
      name="inputWhats"
      class="inputWhats"
      v-model="form.whatsapp" />


    <InputBasico
      ref="Nova senha"
      type="password"
      label="Nova senha"
      name="senha"
      class="inputSenha"
      v-model="form.password"
      v-validate="'min:6'"
      :errorsBag="errors"
    />

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import _ from 'lodash'
import {
  BForm, BButton,
} from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputCelular from '@/components/inputs/pessoais/InputCelular.vue'

export default {
  name: 'AlterarDadosUsuariosForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputCelular,
  },
  methods: {
    valoresIniciaisForm() {
      return {
        nome: '',
        password: '',
        email: '',
        whatsapp: '',
      }
    },
    retornaCamposGravar() {
      if (!this.form.password) {
        return _.omit(this.form, ['password'])
      }

      return this.form
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $small-size;
  }
}

.input {
  &Nome {
    grid-column: 1 / -1;
  }

  &Email {
    @media (min-width: $medium-size) {
      grid-column: 1 / 7;
    }
  }

  &Whats {
    @media (min-width: $medium-size) {
      grid-column: 7 / 11;
    }
  }

  &Senha {
    @media (min-width: $medium-size) {
      grid-column: 1 / 7;
    }
  }

}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
